var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectFinancials(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_689_5946)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8125 7.25V6.125H9.5625V4.4375H8.4375V6.125H7.3125C7.01422 6.1253 6.72825 6.24392 6.51733 6.45483C6.30642 6.66575 6.1878 6.95172 6.1875 7.25V8.9375C6.1878 9.23578 6.30642 9.52175 6.51733 9.73267C6.72825 9.94358 7.01422 10.0622 7.3125 10.0625H10.6875V11.75H6.1875V12.875H8.4375V14.5625H9.5625V12.875H10.6875C10.9858 12.8747 11.2717 12.756 11.4826 12.5451C11.6935 12.3342 11.8122 12.0483 11.8125 11.75V10.0625C11.8122 9.76422 11.6936 9.47825 11.4827 9.26733C11.2718 9.05642 10.9858 8.9378 10.6875 8.9375H7.3125V7.25H11.8125Z",
    fill: "#DCE0E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 2.75C10.335 2.75 11.6401 3.14588 12.7501 3.88758C13.8601 4.62928 14.7253 5.68349 15.2362 6.91689C15.7471 8.15029 15.8808 9.50749 15.6203 10.8169C15.3599 12.1262 14.717 13.329 13.773 14.273C12.829 15.217 11.6262 15.8598 10.3169 16.1203C9.00749 16.3808 7.65029 16.2471 6.41689 15.7362C5.18349 15.2253 4.12928 14.3601 3.38758 13.2501C2.64588 12.1401 2.25 10.835 2.25 9.5C2.25524 7.7114 2.96808 5.99755 4.23282 4.73282C5.49756 3.46808 7.2114 2.75524 9 2.75ZM9 1.625C7.44248 1.625 5.91992 2.08686 4.62489 2.95218C3.32985 3.81749 2.32049 5.0474 1.72445 6.48637C1.12841 7.92534 0.972461 9.50874 1.27632 11.0363C1.58018 12.5639 2.3302 13.9671 3.43154 15.0685C4.53288 16.1698 5.93607 16.9198 7.46367 17.2237C8.99127 17.5275 10.5747 17.3716 12.0136 16.7756C13.4526 16.1795 14.6825 15.1702 15.5478 13.8751C16.4131 12.5801 16.875 11.0575 16.875 9.5C16.8689 7.4133 16.0372 5.41381 14.5617 3.93829C13.0862 2.46276 11.0867 1.63111 9 1.625Z",
    fill: "#DCE0E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_689_5946"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectFinancials);
export default __webpack_public_path__ + "static/media/project_financials.c7a9eb5d402b16478558eecb03f47506.svg";
export { ForwardRef as ReactComponent };